<template>
  <div
    class="role"
    :class="deviceType()"
  >
    <div class="title">
      <img
        v-if="XhLang == 'cn'"
        src="../../../assets/images/role/title-cn.png"
      >
      <img
        v-if="XhLang == 'th'"
        src="../../../assets/images/role/title-th.png"
      >
      <img
        v-if="XhLang == 'en'"
        src="../../../assets/images/role/title-en.png"
      >
    </div>
    <div
      class="role_content"
      v-for="(value, index) in Role"
      v-bind:key="index"
      :class="'c' + index"
      v-show="showRole == index"
    >
      <template
        v-for="(i, key) in value"
        v-bind:key="key"
      >
        <img
          class="detail animate__animated animate__backInRight"
          :class="'detail' + index"
          v-if="i.label == 'detail' && deviceType() == 'pc'"
          :src="i.content"
          v-bind:key="key"
        />
        <img
          class="detail"
          :class="'detail' + index"
          v-if="i.label == 'wap-detail' && deviceType() == 'wap'"
          :src="i.content"
          v-bind:key="key"
        />
        <div
          class="attribute_c"
          :class="deviceType()"
        >
          <img
            class="attribute animate__animated animate__bounceIn animate__delay-1s"
            :class="'attribute' + index"
            v-if="i.label == 'attribute-' + XhLang && deviceType() == 'pc'"
            :src="i.content"
            v-bind:key="key"
          />
          <img
            class="attribute"
            :class="'attribute' + index"
            v-if="i.label == deviceType() + '-attribute-' + XhLang && deviceType() == 'wap'"
            :src="i.content"
            v-bind:key="key"
          />
        </div>
        <img
          class="gif animate__animated animate__fadeInDown "
          :class="'gif' + index"
          v-if="i.label == 'gif'"
          :src="i.content"
          v-bind:key="key"
        />
      </template>
    </div>
    <div class="role_btn">
      <ul>
        <li
          v-for="(value, index) in Role"
          v-bind:key="index"
          @click="changeRole(index)"
          :class="{ active: showRole === index }"
        >
          <template
            v-for="(i, key) in value"
            v-bind:key="key"
          >
            <img
              :class="'header' + key"
              class="header"
              v-if="i.label == 'header'"
              :src="i.content"
              v-bind:key="key"
            />
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>
  
  <script setup>
import { defineProps, watch, ref } from "vue";
import { deviceType } from "@/util/base";

const props = defineProps(["RoleData"]);
const Role = ref("");
const showRole = ref(0);

import { useI18n } from "vue-i18n";
const { locale } = useI18n();
const XhLang = locale.value;

const changeRole = (id) => {
  showRole.value = id;
};

watch(
  [() => props.RoleData],
  ([newVal]) => {
    if (newVal) {
      Role.value = newVal;
    }
  },
  { immediate: true }
);
</script>
  
  <style lang=scss scoped>
.role {
  position: relative;
  width: 90%;
  height: 100%;
  top: 0%;
  .title {
    width: 7.28rem;
    height: 1.39rem;
    position: absolute;
    z-index: 2;
    top: 2.5%;
    left: 50%;
    margin-left: -3.64rem;
    img {
      width: 100%;
    }
  }
  .role_content {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    .detail {
      height: 8rem;
      position: absolute;
      right: 5%;
      bottom: 0.2rem;
    }
    .detail0 {
      height: 8.5rem;
      right: 7%;
    }
    .detail1 {
      height: 8rem;
      bottom: 0rem;
      right: 4%;
    }
    .detail2 {
      height: 9rem;
      right: 8%;
      bottom: -0.8rem;
    }
    .detail3 {
      height: 8rem;
      bottom: 0;
      right: 7%;
    }
    .detail4 {
      height: 8.2rem;
      right: 7%;
      bottom: 0rem;
    }
    .attribute_c.wap {
      width: 4rem;
      position: absolute;
      bottom: 2.5rem;
      right: 0.1rem;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      .attribute3,
      .attribute4 {
        position: absolute;
        right: 0;
      }
    }
    .attribute_c.pc {
      position: absolute;
      height: 1.65rem;
      bottom: 1.8rem;
      left: 18.5%;
      img {
        height: 100%;
      }
    }

    .gif {
      position: absolute;
    }
    .gif0 {
      width: 9rem;
      bottom: 3.5rem;
      left: 7%;
    }
    .gif1 {
      width: 9rem;
      bottom: 3.45rem;
      left: 7%;
    }
    .gif2 {
      width: 8rem;
      bottom: 3.45rem;
      left: 11%;
    }
    .gif3 {
      width: 9rem;
      bottom: 3.3rem;
      left: 11%;
    }
    .gif4 {
      width: 9rem;
      bottom: 2.4rem;
      left: 7%;
    }
  }
  .role_btn {
    position: absolute;
    z-index: 3;
    bottom: 5%;
    left: 18.5%;
    ul {
      display: flex;
      li {
        margin: 0.1rem;
        cursor: pointer;
        img {
          width: 0.9rem;
          height: 0.9rem;
          filter: grayscale(100%);
        }
        &.active {
          img {
            filter: grayscale(0%);
          }
        }
      }
    }
  }
}
.role.wap {
  width: 100%;
  .role_content {
    display: flex;
    justify-content: center;
    .detail {
      width: 100%;
      left: auto;
      right: auto;
      top: 0rem;
      height: auto;
      bottom: auto;
    }
    .attribute {
      width: auto;
      height: 3rem;
    }
    // .attribute1,
    // .attribute3,
    // .attribute4 {
    //   right: 0.6rem;
    // }
    .gif {
      z-index: 2;
      left: 0;
      &.gif0 {
        width: 7rem;
        left: -1.3rem;
        bottom: 2.65rem;
      }
      &.gif1 {
        width: 8rem;
        left: -2rem;
        bottom: 2.65rem;
      }
      &.gif2 {
        width: 7rem;
        left: -1.4rem;
        bottom: 2.6rem;
      }
      &.gif3 {
        width: 8rem;
        left: -1.4rem;
        bottom: 2.5rem;
      }
      &.gif4 {
        width: 8rem;
        left: -2rem;
        bottom: 1.6rem;
      }
    }
  }
  .role_btn {
    left: auto;
    bottom: 0.9rem;
    width: 100%;
    display: flex;
    justify-content: center;
    ul {
      li {
        width: 1.1rem;
        height: 1.1rem;
        img {
          width: 1.1rem;
          height: 1.1rem;
        }
      }
    }
  }
}
</style>